import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TProps } from './models';

export const Img: FC<TProps> = ({
    alt,
    className,
    lazy = true,
    radiusKind = 'default',
    responsive = false,
    srcRetina,
    styles,
    verticalAlign = 'baseline',
    ...rest
}) => {
    return (
        <img
            alt={alt}
            className={cn(
                styles[`${verticalAlign}`],
                styles[`${radiusKind}KindRadius`],
                {
                    [styles.responsive]: responsive,
                },
                className
            )}
            loading={lazy ? 'lazy' : undefined}
            srcSet={srcRetina ? `${srcRetina} 2x` : undefined}
            {...rest}
        />
    );
};
